import axios from "~/plugins/axios";

export default {
  getByCustomer(customerId, includes = []) {
    const url = `/web_api/v1/dossier/by_customer/${customerId}`;
    return axios.get(url, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
};
